/**
 * Lightweight Klaviyo Review Count Formatter
 * Minimal resource usage - only runs when needed
 */
(function() {
  'use strict';
  
  let isProcessing = false;
  let processedCount = 0;
  
  // Lightweight function to update review counts
  function updateReviewCount() {
    if (isProcessing) return;
    isProcessing = true;
    
    const reviewLabels = document.querySelectorAll('.kl_reviews__star_rating_widget__label:not([data-formatted])');
    
    reviewLabels.forEach(function(label) {
      const text = label.textContent.trim();
      const match = text.match(/(\d+)\s+reviews?/i);
      
      if (match) {
        label.textContent = '(' + match[1] + ')';
        label.setAttribute('data-formatted', '1');
        processedCount++;
      }
    });
    
    isProcessing = false;
    return reviewLabels.length;
  }
  
  // Single observer with efficient filtering
  function startObserver() {
    const observer = new MutationObserver(function(mutations) {
      let hasKlaviyoChanges = false;
      
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1 && // Element node
                (node.className && node.className.includes('kl_reviews') ||
                 node.querySelector && node.querySelector('.kl_reviews__star_rating_widget__label'))) {
              hasKlaviyoChanges = true;
              break;
            }
          }
        }
        if (hasKlaviyoChanges) break;
      }
      
      if (hasKlaviyoChanges) {
        setTimeout(updateReviewCount, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Stop observer after 15 seconds
    setTimeout(function() {
      observer.disconnect();
    }, 15000);
  }
  
  // Simple initialization
  function init() {
    updateReviewCount();
    startObserver();
    
    // Single retry after 2 seconds
    setTimeout(function() {
      if (processedCount === 0) {
        updateReviewCount();
      }
    }, 2000);
  }
  
  // Start when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
